export default [
  // 数字证书使用协议；
  {
    path: '/baibu/usbkey-use-protocol',
    name: 'BaibuUsbkeyUseProtocol',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/usbkey-use-protocol.vue'),
  },

  // 查看电子码单;
  {
    path: '/baibu/electron-code-sheet',
    name: 'BaibuElectronCodeSheet',
    component: () => import(/* webpackChunkName: 'BaibuElectronCodeSheet' */ '@/views/baibu/electron-code-sheet.vue'),
  },

  // 关于我们；
  {
    path: '/baibu/about',
    name: 'BaibuAbout',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/about.vue'),
  },

  // 用户服务协议；
  {
    path: '/baibu/license',
    name: 'BaibuLicense',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/license.vue'),
  },

  // 隐私协议
  {
    path: '/baibu/privacy',
    name: 'BaibuPrivacy',
    component: () => import('@/views/baibu/privacy.vue'),
  },

  // 数字证书使用协议
  {
    path: '/baibu/digital-certificate',
    name: 'BaibuDigitalCertificate',
    component: () => import('@/views/baibu/digital-certificate.vue'),
  },

  // 数字证书使用协议跳转页面
  {
    path: '/baibu/digital-certificate-jump',
    name: 'BaibuDigitalCertificateJump',
    component: () => import('@/views/baibu/digital-certificate-jump.vue'),
  },

  // 拍照教程;
  {
    path: '/baibu/teach',
    name: 'BaibuTeach',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/teach.vue'),
  },

  {
    path: '/baibu',
    name: 'BaiRegister',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/index.vue'),
    children: [
      { // 服务商注册
        path: 'provider/register',
        name: 'BaiBuProbiderRegister',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/provider/register'),
        meta: {
          keepAlive: true,
        },
      },
      { // 服务商登陆
        path: 'provider/login',
        name: 'BaiBuProbiderLogin',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/provider/login'),
      },
      { // 服务商登陆
        path: 'provider/login/success',
        name: 'BaiBuProbiderLoginSuccess',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/provider/loginSuccess'),
      },
      { // 服务商修改密码
        path: 'provider/login/password',
        name: 'BaiBuProbiderLoginPassword',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/provider/password'),
      },
      {// 供应商注册
        path: 'supplier/register',
        name: 'BaiBuSupplierRegister',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/register'),
        meta: {
          keepAlive: true,
        },
      },
      { // 供应商登陆
        path: '/baibu/supplier/login',
        name: 'BaiBuSupplierLogin',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/login'),
      },
      { // 供应商修改密码
        path: '/baibu/supplier/password',
        name: 'BaiBuSupplierPassword',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/password'),
      },
      { // 供应商个人中心
        path: '/baibu/supplier/account',
        name: 'BaiBuSupplierAccount',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/account'),
      },
      // 用户注册协议
      {
        path: 'registration-agreement/:type',
        name: 'BaibuRegistrationAgreement',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/registration-agreement.vue'),
      },
      { // 供应商app用户协议
        path: '/baibu/supplier/user-agreement',
        name: 'BaiBuSupplierUserAgreement',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/user-agreement'),
      },
      { // 供应商隐私条款
        path: '/baibu/supplier/privacy',
        name: 'BaiBuSupplierPrivacy',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/supplier/privacy'),
      },
    ],
  },

];
